export let TERMSANDCONDITIONS = {

    'termsConditions': {
        'label': 'Terms & Conditions',
        'elementType': 'checkbox',
        'placeHolder': '',
        'formControlName': 'termsConditions',
        'initialValue': false,
        'altText': '',
        'toolTipText': '',
        'validation': {
            'required': 'true',
            'pattern': '',
            'minLength': '',
            'maxLength': '',
            'errorMessages': {
                'required': 'Terms & Conditions is mandatory',
                'pattern': '',
                'minLength': '',
                'maxLength': ''
            }
        },
        'link': {
            'text': '',
            'url': ''
        },
        'showOrder': ''
    }
};
